<div class="snackbar"
     [ngClass]="gravity">
    <div *ngIf="!this.isFailure">{{title}}</div>
    <div>{{message}}</div>
</div>
